const ComponentsLookup = {
  "default-footer": "DefaultFooter762cdda2575f4544A851F9ec5f9f33bb"
}

export default ComponentsLookup;